import React from 'react';
import { API_BASE } from '../../config';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import '../UI/button.css'
import {
    Box,
    Text,
    Button,
    Center,
    TableContainer,
    Container,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Flex,
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Avatar,
    Tag,
    TagLabel,
    Stack,
    Badge,
    Divider,
    useDisclosure,
    AbsoluteCenter,
} from "@chakra-ui/react";
import axios from 'axios';
import Navigation from "../UI/Navigation";
import '../UI/innerPages.css';
import SidebarAdmin from '../Pages/sideAdmin';


function PharmacistReqs() {
    const [reqs, setReqs] = useState([]);
    const [isOpen1, setIsOpen1] = useState(false);
    const [viewReq, setViewReq] = useState({});
    const navigate = useNavigate();
    // use effect to fetch data from backend

    useEffect(() => {
        const getReqs = async () => {
            try {
                const { data } = await axios.get(`${API_BASE}/admin/applications`, {
                    withCredentials: true,
                });
                setReqs(data);
            } catch (error) {
                console.log(error);
            }
        };
        getReqs();
    }, []);
    const back =()=>  navigate(-1);
    
    const onClose1 = () => setIsOpen1(false);
    const handleAccept = async () => {
      try {
        // router.post('/applications/accept-registeration/:id',acceptRegRequest);
        
        await axios.post(
          `${API_BASE}/admin/applications/accept-registeration/${viewReq._id}`,
          {},
          {
            withCredentials: true,
          }
        );
        setReqs(reqs.filter((req) => req._id !== viewReq._id));
        onClose1();
      } catch (error) {
        console.log(error);
      }
    };

    const handleReject = async () => {
      try {  
        console.log(viewReq._id);      
        await axios.post(
          `${API_BASE}/admin/applications/reject-registeration/${viewReq._id}`,
          {},
          {
            withCredentials: true,
          }
        );
        setReqs(reqs.filter((req) => req._id !== viewReq._id));
        onClose1();
      } catch (error) {
        console.log(error);
      }
    };
  return (
    <>
      <Navigation
      pagetitle={"Doctor Requests"}/>
       <SidebarAdmin
      />
      <div className="content">
        <Box  p={5}  mb={10}>
           
        </Box>
        
        <Center>
        <TableContainer w={'90%'}>
            <Table size='lg'> 
              <Thead>
                <Tr bg={'#2d2d2e'}>
                    <Th color={'white'}>Name</Th>
                    <Th color={'white'}>Userame</Th>
                    <Th color={'white'}><Center>Request Date </Center></Th>
                    <Th color={'white'}> </Th>
                </Tr>
              </Thead>
                <Tbody>
                    {
                        reqs &&
                        reqs.map((req) => {
                            // Check if user.createdAt is a valid date
                            const createdAtDate = req.createdAt instanceof Date
                              ? req.createdAt.toLocaleDateString()
                              : new Date(req.createdAt).toLocaleDateString();
                            return (
                              <Tr key={req._id}>
                                <Td w={'20%'}> {req.Name} </Td>
                                <Td w={'20%'} >
                                    <Text fontSize={'lg'} ml={5}>{req.Username}</Text> 
                                </Td>
                                <Td w={'20%'}> <Center>{createdAtDate}  </Center></Td>
                                <Td w={'20%'}>
                                    <Center>
                                     <Button colorScheme='blue' variant='outline' size='sm'
                                        onClick={() => {
                                            setIsOpen1(true);
                                            setViewReq(req);
                                        }}
                                     >
                                     View Detais</Button>
                                    </Center>
                                </Td>
                              </Tr>
                            );
                          })
                    }
                </Tbody>
            </Table>
        </TableContainer>
        
        </Center>
        <Drawer onClose={onClose1} isOpen={isOpen1} size={'sm'}>
        <DrawerOverlay />
        
        <DrawerContent>
          
            <DrawerCloseButton />
            <DrawerHeader>
            <Flex>
            <Avatar src='https://bit.ly/sage-adebayo' />
            <Box ml='3'>
                <Text fontWeight='bold'>
                {viewReq.Name}
                <Badge ml='1' colorScheme='green'>
                    PENDING
                </Badge>
                </Text>
                <Text fontSize='sm'> {viewReq.Username }</Text>
            </Box>
            </Flex>
                
            </DrawerHeader>
            <DrawerBody>
            <Flex justifyContent={'center'}  alignItems={'center'} >
            <Stack spacing={10}>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Email
            </AbsoluteCenter>
            </Box>
            <Text fontSize={'3xl'}> <Center> {viewReq.Email} </Center> </Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Address
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.address} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                City
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.city} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                State
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.state} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Pincode
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.pincode} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Latitude
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.location?.coordinates?.[1]} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Longitude
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.location?.coordinates?.[0]} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Discount
            </AbsoluteCenter>
            </Box>
            <Text fontSize='3xl'>  <Center> {viewReq.discount} </Center></Text>
            <Box position='relative' >
            <Divider />
            <AbsoluteCenter bg='white' px='4'>
                Working Hours
            </AbsoluteCenter>
            </Box>
            <Text fontSize='md'>
              <Center>
                {viewReq.workingHours ?
                  `Mon ${viewReq.workingHours?.monday?.closed ? 'Closed' : `${viewReq.workingHours?.monday?.from}-${viewReq.workingHours?.monday?.to}`}, Tue ${viewReq.workingHours?.tuesday?.closed ? 'Closed' : `${viewReq.workingHours?.tuesday?.from}-${viewReq.workingHours?.tuesday?.to}`}, Wed ${viewReq.workingHours?.wednesday?.closed ? 'Closed' : `${viewReq.workingHours?.wednesday?.from}-${viewReq.workingHours?.wednesday?.to}`}, Thu ${viewReq.workingHours?.thursday?.closed ? 'Closed' : `${viewReq.workingHours?.thursday?.from}-${viewReq.workingHours?.thursday?.to}`}, Fri ${viewReq.workingHours?.friday?.closed ? 'Closed' : `${viewReq.workingHours?.friday?.from}-${viewReq.workingHours?.friday?.to}`}, Sat ${viewReq.workingHours?.saturday?.closed ? 'Closed' : `${viewReq.workingHours?.saturday?.from}-${viewReq.workingHours?.saturday?.to}`}, Sun ${viewReq.workingHours?.sunday?.closed ? 'Closed' : `${viewReq.workingHours?.sunday?.from}-${viewReq.workingHours?.sunday?.to}`}`
                  : ''}
              </Center>
            </Text>
      </Stack>
            </Flex>
            
            </DrawerBody>
            <DrawerFooter>
            <Button colorScheme='green' m={1} onClick={handleAccept}>Accept</Button>
            <Button variant='outline' colorScheme='red' m={1} onClick={handleReject} >
                Reject
            </Button>

            </DrawerFooter>

        </DrawerContent>
        </Drawer>
        </div> 
    </>

  )
}

export default PharmacistReqs
